<div class="overlay-plus-page" *ngIf="overlayPlusTeam; else emptyState">
    <div class="dpc-screen-loader" *ngIf="isOverlayCrudLoading()" role="status" aria-live="polite">
        <div class="dpc-screen-loader-panel">
            <span class="dpc-screen-spinner"></span>
            <strong>{{getOverlayCrudLoadingTitle()}}</strong>
            <p>{{getOverlayCrudLoadingMessage()}}</p>
        </div>
    </div>

    <ng-container *ngIf="vHubMode; else deviceOverlayHeader">
        <section class="overlay-section">
            <div class="section-head">
                <h2>VHUB Overlay Plus Configuration</h2>
                <span>Powered by RRT-Midlay &mdash; vHUB Server</span>
            </div>
        </section>
        <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedOverlayPlusTab"
            (selectedIndexChange)="onOverlayPlusTabChange($event)">
            <mat-tab label="DPC All"></mat-tab>
            <mat-tab label="Add Peer"></mat-tab>
            <mat-tab label="Device Analytics"></mat-tab>
        </mat-tab-group>
    </ng-container>

    <ng-template #deviceOverlayHeader>
        <section class="overlay-section">
            <div class="section-head">
                <h2>Overlay Plus VCE Configuration</h2>
                <span>Powered by RRT-Midlay &mdash; vCE Client</span>
            </div>
        </section>
        <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedVceOverlayPlusTab"
            (selectedIndexChange)="onVceOverlayPlusTabChange($event)">
            <mat-tab label="Status"></mat-tab>
            <mat-tab label="Device Analytics"></mat-tab>
        </mat-tab-group>
    </ng-template>

    <hr class="y-border" />
    <ng-container *ngIf="vHubMode; else deviceOverlayView">
        <ng-container *ngIf="selectedOverlayPlusTab === 0">
            <section class="overlay-section">
                <div class="section-head">
                    <h3>DPC Services (RRT-Midlay)</h3>
                </div>
                <div class="dpc-actions">
                    <button type="button" class="dpc-action-btn add-dpc-btn" [disabled]="overlayPlusCrudLoading" (click)="openNewDpcModal(newDpcDialog)">+ Add New DPC</button>
                    <button type="button" class="dpc-action-btn refresh-dpc-btn" [disabled]="overlayPlusRefreshing" (click)="refreshOverlayPlusTable()">{{overlayPlusRefreshing ? 'Refreshing...' : 'Refresh'}}</button>
                </div>
                <div class="table-shell">
                    <table class="overlay-table">
                        <thead>
                            <tr>
                                <th>DPC</th>
                                <th>Listen Addr</th>
                                <th>Server URL</th>
                                <th>DPC IP</th>
                                <th>MTU</th>
                                <th>MaxPkt</th>
                            <th>FEC Timeout</th>
                            <th>SDWAN Link</th>
                            <th>Enabled</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dpcServiceRows; let dpcIndex = index">
                            <td><strong>{{row.name}}</strong></td>
                            <td><span class="mono-chip">{{row.listen_addr}}</span></td>
                            <td>{{row.server_url}}</td>
                                <td><span class="mono-chip">{{row.dpc_ip}}</span></td>
                                <td>{{row.mtu}}</td>
                                <td>{{row.maxpacketsize}}</td>
                                <td>{{row.fec_timeout}}</td>
                                <td>{{row.sdwan_link}}</td>
                                <td>
                                    <span class="state-pill" [ngClass]="row.enabled ? 'status-up' : 'status-down'">
                                        {{row.enabled ? 'Yes' : 'No'}}
                                    </span>
                                </td>
                                <td class="actions-cell">
                                    <button type="button" class="table-btn table-btn-edit" [disabled]="overlayPlusCrudLoading" (click)="openEditDpcModal(row, dpcIndex, newDpcDialog)">Edit</button>
                                    <button type="button" class="table-btn table-btn-delete" [disabled]="overlayPlusCrudLoading" (click)="openConfirmDeleteModal('dpc', row, dpcIndex, confirmDeleteDialog)">Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section class="overlay-section">
            <div class="section-head">
                <h3>Authenticated Peers (RRT-Midlay)</h3>
            </div>
            <div class="section-subhead">PSK shown only in Show</div>
        </section>

            <div class="peer-actions">
                <button type="button" class="dpc-action-btn refresh-dpc-btn" [disabled]="overlayPlusRefreshing" (click)="refreshOverlayPlusTable()">{{overlayPlusRefreshing ? 'Refreshing...' : 'Refresh Status'}}</button>
                <button type="button" class="dpc-action-btn reload-auth-btn">Reload Auth</button>
            </div>

            <div class="table-shell">
                <table class="overlay-table">
                    <thead>
                        <tr>
                            <th>MAC</th>
                            <th>Hostname</th>
                            <th>DPC</th>
                            <th>Assigned IPs</th>
                            <th>Link / Lane</th>
                            <th>Ulay / Lane Assurance</th>
                            <th>Weight TX/RX</th>
                        <th>WAN ID</th>
                        <th>Uptime</th>
                        <th>State</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                        <tr *ngFor="let row of tableRows">
                            <td>
                                <span class="mono-chip" *ngIf="row.showPeerSummary">{{row.mac}}</span>
                            </td>
                            <td class="hostname-cell">
                                <ng-container *ngIf="row.showPeerSummary">{{row.hostname}}</ng-container>
                            </td>
                            <td>
                                <span [ngClass]="{'local-pill': row.local}" *ngIf="row.showPeerSummary">{{row.dpc}}</span>
                            </td>
                            <td>
                                <div class="ip-stack" *ngIf="row.showPeerSummary">
                                    <div *ngFor="let line of row.assignedIpLines" [class.primary-ip]="line.primary">
                                        <span class="ip-label" *ngIf="line.label">{{line.label}}</span>
                                        {{line.value}}
                                    </div>
                                </div>
                            </td>
                            <td>{{row.linkLane}}</td>
                            <td>
                                <div class="assurance" *ngIf="row.assuranceLines?.length">
                                    <div *ngFor="let line of row.assuranceLines">{{line}}</div>
                                </div>
                            </td>
                            <td>{{row.weight || '-'}}</td>
                            <td>
                                <ng-container *ngIf="row.showPeerSummary">{{row.wanId}}</ng-container>
                            </td>
                            <td>
                                <ng-container *ngIf="row.showPeerSummary">{{row.uptime}}</ng-container>
                            </td>
                        <td>
                            <span *ngIf="row.state" class="state-pill" [ngClass]="getStateClass(row.state)">
                                {{getStateLabel(row.state)}}
                            </span>
                        </td>
                        <td class="actions-cell">
                            <ng-container *ngIf="row.showPeerSummary">
                                <button type="button" class="table-btn table-btn-show" (click)="openPeerShowModal(row, peerShowDialog)">Show</button>
                                <button type="button" class="table-btn table-btn-delete" [disabled]="overlayPlusCrudLoading" (click)="openConfirmDeleteModal('peer', row, -1, confirmDeleteDialog)">Delete</button>
                            </ng-container>
                        </td>
                    </tr>
                    <tr *ngIf="!tableRows.length">
                            <td colspan="11" class="text-center">No Overlay Plus peer data available.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <section class="overlay-section add-peer-section" *ngIf="selectedOverlayPlusTab === 1">
            <div class="section-head">
                <h3>Add Peer</h3>
            </div>

            <div class="provisioning-output" *ngIf="addPeerProvisioningReady">
                <div class="provisioning-alert">Peer added. Auth reloaded / Fetching provisioning...</div>

                <h3>Provisioning Output</h3>
                <div class="provisioning-grid">
                    <div class="provisioning-panel">
                        <div class="provisioning-label">UI Block - paste into device Overlay Plus -> Connect</div>
                        <pre class="ui-block-output">{{addPeerUiBlock}}</pre>
                        <button type="button" class="mini-btn copied-btn" *ngIf="copiedProvisioningTarget === 'add-peer-ui'">Copied</button>
                        <button type="button" class="mini-btn" *ngIf="copiedProvisioningTarget !== 'add-peer-ui'" (click)="copyProvisioningText(addPeerUiBlock, 'add-peer-ui')">Copy</button>
                    </div>
                    <div class="provisioning-panel">
                        <div class="provisioning-label">CLI Script - paste into device SSH terminal</div>
                        <pre class="cli-script-output">{{addPeerCliScript}}</pre>
                        <button type="button" class="mini-btn copied-btn" *ngIf="copiedProvisioningTarget === 'add-peer-cli'">Copied</button>
                        <button type="button" class="mini-btn" *ngIf="copiedProvisioningTarget !== 'add-peer-cli'" (click)="copyProvisioningText(addPeerCliScript, 'add-peer-cli')">Copy</button>
                    </div>
                </div>

                <button type="button" class="mini-btn add-another-peer-btn" (click)="showAddPeerForm()">Add Another Peer</button>
            </div>

            <div class="peer-form" [hidden]="addPeerProvisioningReady">
                <label class="form-field narrow-field">
                    <span>Client Device Type <small>(seeds tuning defaults)</small></span>
                    <select [(ngModel)]="addPeerModel.clientDeviceType">
                        <option *ngFor="let option of clientDeviceTypeOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                </label>

                <div class="field-grid two-col">
                    <label class="form-field" [class.invalid-field]="isAddPeerFieldInvalid('clientMac')">
                        <span>Client MAC <span class="required-star">*</span></span>
                        <div class="client-mac-lookup">
                            <input type="text" [(ngModel)]="addPeerModel.clientMac" [placeholder]="addPeerPlaceholders.clientMac" (focus)="onClientMacInputFocus()" (blur)="onClientMacInputBlur()" (input)="onClientMacInputChange()" (keydown)="onClientMacKeydown($event)" autocomplete="off" />
                            <div class="client-mac-options" *ngIf="clientMacLookupOpen && getFilteredClientDeviceLookupRows().length">
                                <button type="button" *ngFor="let device of getFilteredClientDeviceLookupRows(); let deviceIndex = index" [class.active]="deviceIndex === clientMacLookupIndex" (mousedown)="selectClientLookupDevice(device)">
                                    {{getClientLookupLabel(device)}}
                                </button>
                            </div>
                        </div>
                        <span class="field-error" *ngIf="isAddPeerFieldInvalid('clientMac')">Client MAC is required.</span>
                    </label>
                    <label class="form-field">
                        <span>Client Hostname <small>(label only)</small></span>
                        <input type="text" [(ngModel)]="addPeerModel.clientHostname" [placeholder]="addPeerPlaceholders.clientHostname" />
                    </label>
                    <label class="form-field" [class.invalid-field]="isAddPeerFieldInvalid('dpcService')">
                        <span>DPC Service <span class="required-star">*</span></span>
                        <select [(ngModel)]="addPeerModel.dpcService">
                            <option *ngFor="let dpc of dpcServiceRows" [value]="dpc.name + ' (' + dpc.server_url + ')'">
                                {{dpc.name}} ({{dpc.server_url}})
                            </option>
                        </select>
                        <span class="field-error" *ngIf="isAddPeerFieldInvalid('dpcService')">DPC Service is required.</span>
                    </label>
                    <label class="form-field">
                        <span>DPC IP Assignment</span>
                        <select [(ngModel)]="addPeerModel.dpcIpAssignment">
                            <option *ngFor="let option of dpcIpAssignmentOptions" [value]="option.value">{{option.label}}</option>
                        </select>
                    </label>
                    <label class="form-field" *ngIf="isManualAddPeerDpcIp()">
                        <span>DPC IP <small>(CIDR)</small></span>
                        <input type="text" [(ngModel)]="addPeerModel.dpcIp" [placeholder]="addPeerPlaceholders.dpcIp" />
                    </label>
                </div>

                <div class="selection-error" *ngIf="addPeerSelectionError">{{addPeerSelectionError}}</div>

                <label class="form-field psk-field" [class.invalid-field]="isAddPeerFieldInvalid('psk')">
                    <span>PSK <span class="required-star">*</span></span>
                    <div class="inline-action">
                        <input [type]="showPsk ? 'text' : 'password'" [(ngModel)]="addPeerModel.psk" placeholder="click Generate" />
                        <button type="button" class="mini-btn" (click)="generatePsk()">Generate</button>
                        <button type="button" class="mini-btn" (click)="showPsk = !showPsk">{{showPsk ? 'Hide' : 'Show'}}</button>
                    </div>
                    <span class="field-error" *ngIf="isAddPeerFieldInvalid('psk')">PSK is required.</span>
                </label>

                <div class="field-grid two-col">
                    <label class="form-field">
                        <span>WAN ID</span>
                        <input type="text" [(ngModel)]="addPeerModel.wanId" [placeholder]="addPeerPlaceholders.wanId" />
                    </label>
                    <label class="form-field">
                        <span>WAN Subnet <small>(space-separated CIDRs)</small></span>
                        <input type="text" [(ngModel)]="addPeerModel.wanSubnet" [placeholder]="addPeerPlaceholders.wanSubnet" />
                    </label>
                    <label class="form-field">
                        <span>DMZ <small>(optional) DMZ IPs (space-separated CIDRs)</small></span>
                        <input type="text" [(ngModel)]="addPeerModel.dmzIp" [placeholder]="addPeerPlaceholders.dmzIp" />
                    </label>
                    <label class="form-field">
                        <span>DMZ Subnets <small>(space-separated CIDRs)</small></span>
                        <input type="text" [(ngModel)]="addPeerModel.dmzSubnets" [placeholder]="addPeerPlaceholders.dmzSubnets" />
                    </label>
                </div>

                <div class="config-block">
                    <div class="block-title">VCE Provisioning <small>(written to vce_provision in auth file - applied to device at install time)</small></div>

                    <div class="compact-group">
                        <div class="block-label">Multipath Link Management</div>
                        <div class="link-pickers link-column-grid">
                            <label class="link-picker-field">Link 1 (Primary)
                                <div class="link-picker">
                                    <button type="button" class="link-picker-trigger" (click)="toggleLinkPicker('add-link1')">{{addPeerModel.link1 || addPeerPlaceholders.link1}}</button>
                                    <div class="link-picker-menu" *ngIf="openLinkPickerKey === 'add-link1'">
                                        <button type="button" *ngFor="let option of linkSelectOptions" (click)="setLinkPickerValue(addPeerModel, 'link1', option)">{{option}}</button>
                                        <input type="text" [(ngModel)]="customLinkValues['add-link1']" placeholder="type link id..." />
                                        <button type="button" class="link-set-btn" (click)="setCustomLinkPickerValue(addPeerModel, 'link1', 'add-link1')">Set</button>
                                        <button type="button" class="link-clear-btn" (click)="clearLinkPickerValue(addPeerModel, 'link1')">[Clear]</button>
                                    </div>
                                </div>
                            </label>
                            <label class="link-picker-field">Link 2 (Backup)
                                <div class="link-picker">
                                    <button type="button" class="link-picker-trigger" (click)="toggleLinkPicker('add-link2')">{{addPeerModel.link2 || addPeerPlaceholders.link2}}</button>
                                    <div class="link-picker-menu" *ngIf="openLinkPickerKey === 'add-link2'">
                                        <button type="button" *ngFor="let option of linkSelectOptions" (click)="setLinkPickerValue(addPeerModel, 'link2', option)">{{option}}</button>
                                        <input type="text" [(ngModel)]="customLinkValues['add-link2']" placeholder="type link id..." />
                                        <button type="button" class="link-set-btn" (click)="setCustomLinkPickerValue(addPeerModel, 'link2', 'add-link2')">Set</button>
                                        <button type="button" class="link-clear-btn" (click)="clearLinkPickerValue(addPeerModel, 'link2')">[Clear]</button>
                                    </div>
                                </div>
                            </label>
                            <label class="link-picker-field">Link 3 (Optional)
                                <div class="link-picker">
                                    <button type="button" class="link-picker-trigger" (click)="toggleLinkPicker('add-link3')">{{addPeerModel.link3 || addPeerPlaceholders.link3}}</button>
                                    <div class="link-picker-menu" *ngIf="openLinkPickerKey === 'add-link3'">
                                        <button type="button" *ngFor="let option of linkSelectOptions" (click)="setLinkPickerValue(addPeerModel, 'link3', option)">{{option}}</button>
                                        <input type="text" [(ngModel)]="customLinkValues['add-link3']" placeholder="type link id..." />
                                        <button type="button" class="link-set-btn" (click)="setCustomLinkPickerValue(addPeerModel, 'link3', 'add-link3')">Set</button>
                                        <button type="button" class="link-clear-btn" (click)="clearLinkPickerValue(addPeerModel, 'link3')">[Clear]</button>
                                    </div>
                                </div>
                            </label>
                            <label class="link-picker-field">Link 4 (Optional)
                                <div class="link-picker">
                                    <button type="button" class="link-picker-trigger" (click)="toggleLinkPicker('add-link4')">{{addPeerModel.link4 || addPeerPlaceholders.link4}}</button>
                                    <div class="link-picker-menu" *ngIf="openLinkPickerKey === 'add-link4'">
                                        <button type="button" *ngFor="let option of linkSelectOptions" (click)="setLinkPickerValue(addPeerModel, 'link4', option)">{{option}}</button>
                                        <input type="text" [(ngModel)]="customLinkValues['add-link4']" placeholder="type link id..." />
                                        <button type="button" class="link-set-btn" (click)="setCustomLinkPickerValue(addPeerModel, 'link4', 'add-link4')">Set</button>
                                        <button type="button" class="link-clear-btn" (click)="clearLinkPickerValue(addPeerModel, 'link4')">[Clear]</button>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div class="compact-group">
                        <div class="block-label">Path Management</div>
                        <div class="micro-grid path-management-grid">
                            <label>Mode<select [(ngModel)]="addPeerModel.mode"><option *ngFor="let option of pathManagementModeOptions" [value]="option.value">{{option.label}}</option></select></label>
                            <div class="path-management-links link-column-grid">
                                <label>{{addPeerModel.link1 || 'link1'}}<input type="text" [(ngModel)]="addPeerModel.routeTable1" [placeholder]="addPeerPlaceholders.routeTable1" /></label>
                                <label>{{addPeerModel.link2 || 'link2'}}<input type="text" [(ngModel)]="addPeerModel.routeTable2" [placeholder]="addPeerPlaceholders.routeTable2" /></label>
                                <label *ngIf="isAddPeerLinkSet(addPeerModel.link3)">{{addPeerModel.link3}}<input type="text" [(ngModel)]="addPeerModel.routeTable3" [placeholder]="addPeerModel.link3" /></label>
                                <label *ngIf="isAddPeerLinkSet(addPeerModel.link4)">{{addPeerModel.link4}}<input type="text" [(ngModel)]="addPeerModel.routeTable4" [placeholder]="addPeerModel.link4" /></label>
                            </div>
                        </div>
                    </div>

                    <div class="compact-group">
                        <div class="block-label">Path Distribution (weights TX / RX)</div>
                        <div class="path-distribution-grid link-column-grid">
                            <label>link1
                                <span class="tx-rx-inputs">
                                    <input type="number" [(ngModel)]="addPeerModel.weightTx1" placeholder="TX" />
                                    <span class="tx-rx-separator">/</span>
                                    <input type="number" [(ngModel)]="addPeerModel.weightRx1" placeholder="RX" />
                                </span>
                            </label>
                            <label>link2
                                <span class="tx-rx-inputs">
                                    <input type="number" [(ngModel)]="addPeerModel.weightTx2" placeholder="TX" />
                                    <span class="tx-rx-separator">/</span>
                                    <input type="number" [(ngModel)]="addPeerModel.weightRx2" placeholder="RX" />
                                </span>
                            </label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link3)">{{addPeerModel.link3}}
                                <span class="tx-rx-inputs">
                                    <input type="number" [(ngModel)]="addPeerModel.weightTx3" placeholder="TX" />
                                    <span class="tx-rx-separator">/</span>
                                    <input type="number" [(ngModel)]="addPeerModel.weightRx3" placeholder="RX" />
                                </span>
                            </label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link4)">{{addPeerModel.link4}}
                                <span class="tx-rx-inputs">
                                    <input type="number" [(ngModel)]="addPeerModel.weightTx4" placeholder="TX" />
                                    <span class="tx-rx-separator">/</span>
                                    <input type="number" [(ngModel)]="addPeerModel.weightRx4" placeholder="RX" />
                                </span>
                            </label>
                        </div>
                    </div>

                    <div class="compact-group">
                        <div class="block-label">Failover Timeouts (ms)</div>
                        <div class="micro-grid link-column-grid">
                            <label>link1<input type="number" [(ngModel)]="addPeerModel.failoverTimeout1" [placeholder]="getAddPeerTimeoutDefault(1)" /></label>
                            <label>link2<input type="number" [(ngModel)]="addPeerModel.failoverTimeout2" [placeholder]="getAddPeerTimeoutDefault(2)" /></label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link3)">{{addPeerModel.link3}}<input type="number" [(ngModel)]="addPeerModel.failoverTimeout3" [placeholder]="getAddPeerTimeoutDefault(3)" /></label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link4)">{{addPeerModel.link4}}<input type="number" [(ngModel)]="addPeerModel.failoverTimeout4" [placeholder]="getAddPeerTimeoutDefault(4)" /></label>
                        </div>
                    </div>

                    <div class="compact-group">
                        <div class="block-label">Link Restore Flapcheck (ms)</div>
                        <div class="micro-grid link-column-grid">
                            <label>link1<input type="number" [(ngModel)]="addPeerModel.flapcheck1" [placeholder]="addPeerPlaceholders.flapcheck1" /></label>
                            <label>link2<input type="number" [(ngModel)]="addPeerModel.flapcheck2" [placeholder]="addPeerPlaceholders.flapcheck2" /></label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link3)">{{addPeerModel.link3}}<input type="number" [(ngModel)]="addPeerModel.flapcheck3" [placeholder]="addPeerPlaceholders.flapcheck3" /></label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link4)">{{addPeerModel.link4}}<input type="number" [(ngModel)]="addPeerModel.flapcheck4" [placeholder]="addPeerPlaceholders.flapcheck4" /></label>
                        </div>
                    </div>

                    <div class="compact-group">
                        <div class="block-label">Transport per Link</div>
                        <div class="micro-grid link-column-grid">
                            <label>link1<select [(ngModel)]="addPeerModel.transport1"><option *ngFor="let option of transportProtocolOptions" [value]="option.value">{{option.label}}</option></select></label>
                            <label>link2<select [(ngModel)]="addPeerModel.transport2"><option *ngFor="let option of transportProtocolOptions" [value]="option.value">{{option.label}}</option></select></label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link3)">{{addPeerModel.link3}}<select [(ngModel)]="addPeerModel.transport3"><option *ngFor="let option of transportProtocolOptions" [value]="option.value">{{option.label}}</option></select></label>
                            <label *ngIf="isAddPeerLinkSet(addPeerModel.link4)">{{addPeerModel.link4}}<select [(ngModel)]="addPeerModel.transport4"><option *ngFor="let option of transportProtocolOptions" [value]="option.value">{{option.label}}</option></select></label>
                        </div>
                    </div>

                    <div class="compact-group">
                        <div class="block-label">Distribution</div>
                        <label class="form-field tiny-field">
                            <select [(ngModel)]="addPeerModel.distribution">
                                <option *ngFor="let option of distributionModeOptions" [value]="option.value">{{option.label}}</option>
                            </select>
                        </label>
                        <label class="form-field small-number">
                            <span>Max Packet Size</span>
                            <input type="number" [(ngModel)]="addPeerModel.maxPacketSize" [placeholder]="addPeerPlaceholders.maxPacketSize" />
                        </label>
                    </div>

                    <div class="compact-group perf-tuning">
                        <div class="block-label">Performance Tuning <small>(per-team transport knobs - defaults from client device type)</small></div>
                        <div class="micro-grid">
                            <label>rseq_hold_ms (0=off)<input type="number" [(ngModel)]="addPeerModel.rseqHoldMs" [placeholder]="addPeerPlaceholders.rseqHoldMs" /></label>
                            <label>rseq_thin_acks (0=off)<input type="number" [(ngModel)]="addPeerModel.rseqThinkAcks" [placeholder]="addPeerPlaceholders.rseqThinkAcks" /></label>
                            <label>maxblocks<input type="number" [(ngModel)]="addPeerModel.maxblocks" [placeholder]="addPeerPlaceholders.maxblocks" /></label>
                            <label>fec_group_hold<input type="text" [(ngModel)]="addPeerModel.fecGroupHold" [placeholder]="addPeerPlaceholders.fecGroupHold" /></label>
                            <label>fec_group_hold_depth (blank=auto)<input type="text" [(ngModel)]="addPeerModel.fecGroupHoldDepth" [placeholder]="addPeerPlaceholders.fecGroupHoldDepth" /></label>
                        </div>
                    </div>
                </div>

                <div class="config-block qfec-block">
                    <div class="block-title">Assured Traffic Flows <small>(default lane + optional Q-FEC lanes)</small></div>
                    <label class="form-field default-lane-field">
                        <span>Default Lane (Orig:Dupes) <small>0:0 = disabled</small></span>
                        <input type="text" [(ngModel)]="addPeerModel.defaultLaneOrigDupes" [placeholder]="addPeerPlaceholders.defaultLaneOrigDupes" />
                    </label>
                    <div class="qfec-lane-editor">
                        <div class="qfec-lane-row" *ngFor="let lane of qfecLanes; let laneIndex = index">
                            <label>
                                <span>Lane Q</span>
                                <input type="number" [(ngModel)]="lane.laneQ" />
                            </label>
                            <label>
                                <span>Orig:Dupes</span>
                                <input type="text" [(ngModel)]="lane.origDupes" />
                            </label>
                            <label>
                                <span>Mode</span>
                                <select [(ngModel)]="lane.mode">
                                    <option *ngFor="let option of fecLaneModeOptions" [value]="option.value">{{option.label}}</option>
                                </select>
                            </label>
                            <label>
                                <span>Steer Class</span>
                                <input type="number" [(ngModel)]="lane.steer" />
                            </label>
                            <button type="button" class="lane-remove-btn" (click)="removeQfecLane(laneIndex)">x</button>
                        </div>
                    </div>
                    <button type="button" class="mini-btn add-lane-btn" (click)="addQfecLane()">+ Add Lane</button>
                </div>

                <div class="form-actions">
                    <button type="button" class="save-btn" [disabled]="overlayPlusCrudLoading || addPeerSaveLoading" (click)="saveAddPeer(applyActivationDialog)">
                        <span class="btn-spinner" *ngIf="isPeerCrudLoading('add')"></span>
                        {{isPeerCrudLoading('add') ? 'Adding Peer...' : 'Save & Apply'}}
                    </button>
                    <button type="button" class="cancel-btn" [disabled]="overlayPlusCrudLoading || addPeerSaveLoading" (click)="selectedOverlayPlusTab = 0">Cancel</button>
                </div>
            </div>
        </section>

        <section class="overlay-section" *ngIf="selectedOverlayPlusTab === 2">
            <div class="section-head">
                <h3>Device Analytics</h3>
            </div>
            <div class="device-analytics-view-tabs" role="tablist" aria-label="Device Analytics views">
                <button type="button" role="tab" [attr.aria-selected]="selectedDeviceAnalyticsView === 'device'"
                    [class.active]="selectedDeviceAnalyticsView === 'device'"
                    (click)="onDeviceAnalyticsViewChange('device')">
                    <strong>Device</strong>
                    <span>Detailed analytics for a selected device</span>
                </button>
                <button type="button" role="tab" [attr.aria-selected]="selectedDeviceAnalyticsView === 'topDevices'"
                    [class.active]="selectedDeviceAnalyticsView === 'topDevices'"
                    (click)="onDeviceAnalyticsViewChange('topDevices')">
                    <strong>Top Devices</strong>
                    <span>Compare device consumption across the vHUB</span>
                </button>
            </div>

            <ng-container *ngIf="selectedDeviceAnalyticsView === 'device'">
            <div class="selected-device-analytics-heading">
                <div>
                    <span class="top-devices-eyebrow">vHUB Device Intelligence</span>
                    <h4>
                        {{isLaneAnalyticsDeviceSelected() ? getSelectedLaneAnalyticsDeviceLabel() : 'Selected Device'}}
                        <span class="top-devices-heading-metric">Device</span>
                    </h4>
                    <p>Inspect lane and underlay performance for one device during the selected period.</p>
                </div>
                <div class="top-devices-heading-meta" aria-label="Current device analytics settings">
                    <span>{{getLaneAnalyticsRangeLabel()}}</span>
                    <span *ngIf="isLaneAnalyticsDeviceSelected()">{{selectedLaneAnalyticsDevice}}</span>
                    <span>Device scoped</span>
                </div>
            </div>

            <mat-tab-group animationDuration="0ms" class="lane-analytics-tabs" [selectedIndex]="selectedLaneAnalyticsRange"
                (selectedIndexChange)="onLaneAnalyticsRangeChange($event)">
                <mat-tab label="Last 4 Hrs"></mat-tab>
                <mat-tab label="Last 24 Hrs"></mat-tab>
                <mat-tab label="Last 7 Days"></mat-tab>
                <mat-tab label="This Month"></mat-tab>
                <mat-tab label="Last Month"></mat-tab>
            </mat-tab-group>
            <ng-container *ngTemplateOutlet="laneAnalyticsTimezonePicker"></ng-container>

            <div class="lane-analytics-filter-bar">
                <label class="lane-analytics-device-filter">
                    <span>Device</span>
                    <div class="lane-analytics-device-picker">
                        <input type="search" [(ngModel)]="laneAnalyticsDeviceSearchText"
                            placeholder="Search or select a device"
                            aria-label="Search or select a device"
                            autocomplete="off"
                            (focus)="onLaneAnalyticsDeviceSearchFocus()"
                            (blur)="onLaneAnalyticsDeviceSearchBlur()"
                            (input)="onLaneAnalyticsDeviceSearchInput()" />
                        <span class="lane-analytics-picker-arrow" aria-hidden="true">&#9662;</span>
                        <div class="lane-analytics-device-options" *ngIf="laneAnalyticsDevicePickerOpen">
                            <button type="button"
                                *ngFor="let option of getFilteredLaneAnalyticsDeviceOptions(); trackBy: trackByLaneAnalyticsOption"
                                [class.active]="option.value === selectedLaneAnalyticsDevice"
                                (mousedown)="$event.preventDefault(); selectLaneAnalyticsDeviceOption(option)">
                                <strong>{{option.label}}</strong>
                                <small>{{option.value}}</small>
                            </button>
                            <div class="lane-analytics-device-options-empty"
                                *ngIf="!getFilteredLaneAnalyticsDeviceOptions().length">
                                No matching devices
                            </div>
                        </div>
                    </div>
                </label>
            </div>

            <div class="lane-analytics-device-list-status" *ngIf="laneAnalyticsDevicesLoading">Loading devices...</div>
            <div class="lane-analytics-device-list-status error" *ngIf="laneAnalyticsDevicesError">
                {{laneAnalyticsDevicesError}}
                <button type="button" (click)="loadLaneAnalyticsDevices()">Retry</button>
            </div>

            <div class="lane-analytics-state lane-analytics-loading-state" *ngIf="laneAnalyticsLoading">
                <span class="lane-analytics-spinner" aria-hidden="true"></span>
                <div>
                    <strong>Loading device analytics...</strong>
                    <span>Retrieving lane and underlay metrics for the selected device.</span>
                </div>
            </div>

            <div class="lane-analytics-state lane-analytics-error-state" *ngIf="laneAnalyticsError && !laneAnalyticsLoading">
                <div>
                    <strong>{{laneAnalyticsError}}</strong>
                    <span>Please retry the request.</span>
                </div>
                <button type="button" class="mini-btn" (click)="retryLaneAnalytics()">Retry</button>
            </div>

            <div class="lane-analytics-state lane-analytics-selection-prompt"
                *ngIf="!laneAnalyticsLoading && !laneAnalyticsError && !isLaneAnalyticsSelectionReady()">
                <div>
                    <strong>Select a device to view analytics</strong>
                    <span>Search by device name, MAC address, or model.</span>
                </div>
            </div>

            <ng-container *ngIf="laneAnalyticsRows as laneRows">
                <ng-container *ngIf="!laneAnalyticsLoading && !laneAnalyticsError && isLaneAnalyticsSelectionReady() && laneRows.length; else noLaneAnalyticsData">
                    <ng-container *ngIf="getLaneAnalyticsTotal() as deviceTotal">
                        <div class="top-devices-kpis selected-device-kpis" aria-label="Selected device summary">
                            <div class="top-devices-kpi-card">
                                <div class="top-devices-kpi-label"><span>Total Data</span><i aria-hidden="true">DATA</i></div>
                                <strong>{{formatBytes(deviceTotal.txBytes + deviceTotal.rxBytes)}}</strong>
                                <small>Combined transmit and receive data</small>
                            </div>
                            <div class="top-devices-kpi-card">
                                <div class="top-devices-kpi-label"><span>TX Data</span><i aria-hidden="true">TX</i></div>
                                <strong>{{formatBytes(deviceTotal.txBytes)}}</strong>
                                <small>Transmitted during this period</small>
                            </div>
                            <div class="top-devices-kpi-card">
                                <div class="top-devices-kpi-label"><span>RX Data</span><i aria-hidden="true">RX</i></div>
                                <strong>{{formatBytes(deviceTotal.rxBytes)}}</strong>
                                <small>Received during this period</small>
                            </div>
                            <div class="top-devices-kpi-card">
                                <div class="top-devices-kpi-label"><span>Bandwidth</span><i aria-hidden="true">BW</i></div>
                                <strong>{{deviceTotal.txMbps + deviceTotal.rxMbps | number:'1.0-3'}} Mbps</strong>
                                <small>Combined lane bandwidth</small>
                            </div>
                            <div class="top-devices-kpi-card">
                                <div class="top-devices-kpi-label"><span>Lanes</span><i aria-hidden="true">LN</i></div>
                                <strong>{{laneRows.length}}</strong>
                                <small>Reporting QFEC lanes</small>
                            </div>
                            <div class="top-devices-kpi-card">
                                <div class="top-devices-kpi-label"><span>Underlays</span><i aria-hidden="true">UL</i></div>
                                <strong>{{getCachedLaneAnalyticsTableLinkRows(laneRows[0]?.peer).length}}</strong>
                                <small>Reporting transport links</small>
                            </div>
                        </div>
                    </ng-container>

                    <div class="lane-analytics-grid">
                        <div class="table-shell lane-analytics-table-shell">
                            <table class="overlay-table lane-analytics-table">
                                <caption>SDWAN, Overlay Plus, Device Analytics:</caption>
                                <thead>
                                    <tr>
                                        <th>Underlays and Lanes</th>
                                        <th>FEC</th>
                                        <th>Mode</th>
                                        <th>Q-Class</th>
                                        <th>TX Mbps</th>
                                        <th>TX Bytes</th>
                                        <th>RX Mbps</th>
                                        <th>RX Bytes</th>
                                        <th>Loss %</th>
                                        <th>Avg Latency</th>
                                        <th>P90 Latency</th>
                                        <th>Jitter</th>
                                        <th>MOS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let row of laneRows; let rowIndex = index; trackBy: trackByLaneAnalyticsRow">
                                        <tr class="lane-link-row"
                                            *ngFor="let linkRow of (isFirstLaneAnalyticsPeerRow(laneRows, row, rowIndex) ? getCachedLaneAnalyticsTableLinkRows(row.peer) : []); let linkIndex = index; trackBy: trackByLaneAnalyticsLinkRow">
                                            <td><span class="mono-chip lane-link-chip">{{linkRow.linkLabel}}</span></td>
                                            <td>-</td>
                                            <td>{{linkRow.mode}}</td>
                                            <td>-</td>
                                            <td>{{linkRow.txMbps | number:'1.0-3'}}</td>
                                            <td>{{formatBytes(linkRow.txBytes)}}</td>
                                            <td>{{linkRow.rxMbps | number:'1.0-3'}}</td>
                                            <td>{{formatBytes(linkRow.rxBytes)}}</td>
                                            <td>{{linkRow.lossPct | number:'1.0-2'}}</td>
                                            <td>{{linkRow.decodeLatencyAvg}}ms</td>
                                            <td>{{linkRow.decodeLatencyP90}}ms</td>
                                            <td>{{linkRow.jitter}}ms</td>
                                            <td>{{linkRow.mos}}</td>
                                        </tr>
                                        <tr>
                                            <td><span class="mono-chip lane-value-chip">{{row.laneLabel}}</span></td>
                                            <td>{{row.ratio}}</td>
                                            <td>{{row.mode}}</td>
                                            <td>{{row.qClass}}</td>
                                            <td>{{row.txMbps | number:'1.0-3'}}</td>
                                            <td>{{formatBytes(row.txBytes)}}</td>
                                            <td>{{row.rxMbps | number:'1.0-3'}}</td>
                                            <td>{{formatBytes(row.rxBytes)}}</td>
                                            <td>{{row.lossPct}}</td>
                                            <td>{{row.decodeLatencyAvg}}ms</td>
                                            <td>{{row.decodeLatencyP90}}ms</td>
                                            <td>{{row.jitter}}ms</td>
                                            <td>{{row.mos}}</td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>

                        <div class="lane-analytics-graph-grid">
                            <div class="lane-analytics-graph" *ngFor="let graph of laneAnalyticsGraphs; trackBy: trackByLaneAnalyticsGraph" (dblclick)="openLaneAnalyticsChart(graph, expandedLaneChart)" title="Double-click to expand">
                                <h6>{{graph.title}}</h6>
                                <div class="lane-analytics-legend" *ngIf="graph.legendGroups?.length">
                                    <div class="lane-analytics-legend-group" *ngFor="let group of graph.legendGroups; trackBy: trackByLaneAnalyticsLegendGroup">
                                        <div class="lane-analytics-legend-row" *ngIf="group.linkItems?.length">
                                            <div class="lane-analytics-legend-items">
                                            <button type="button" class="lane-analytics-legend-item"
                                                *ngFor="let item of group.linkItems; trackBy: trackByLaneAnalyticsLegendItem"
                                                [class.hidden]="item.hidden"
                                                [attr.aria-pressed]="!item.hidden"
                                                [attr.aria-label]="(item.hidden ? 'Show ' : 'Hide ') + item.laneLabel"
                                                (click)="toggleLaneAnalyticsSeries(graph, item)">
                                                <span class="lane-analytics-legend-swatch" [style.background]="item.color"></span>
                                                {{item.laneLabel}}
                                            </button>
                                            </div>
                                        </div>
                                        <div class="lane-analytics-legend-row" *ngIf="group.laneItems?.length">
                                            <div class="lane-analytics-legend-items">
                                            <button type="button" class="lane-analytics-legend-item"
                                                *ngFor="let item of group.laneItems; trackBy: trackByLaneAnalyticsLegendItem"
                                                [class.hidden]="item.hidden"
                                                [attr.aria-pressed]="!item.hidden"
                                                [attr.aria-label]="(item.hidden ? 'Show ' : 'Hide ') + item.laneLabel"
                                                (click)="toggleLaneAnalyticsSeries(graph, item)">
                                                <span class="lane-analytics-legend-swatch" [style.background]="item.color"></span>
                                                {{item.laneLabel}}
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="lane-analytics-chart-body">
                                    <canvas #laneAnalyticsCanvas tabindex="0" (keydown.enter)="openLaneAnalyticsChart(graph, expandedLaneChart)" aria-label="Chart. Double-click or press Enter to expand." title="Double-click to expand"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noLaneAnalyticsData>
                <div class="lane-analytics-state" *ngIf="!laneAnalyticsLoading && !laneAnalyticsError && isLaneAnalyticsSelectionReady()">
                    <div>
                        <strong>No analytics data available for this device.</strong>
                        <span>Try another time range or select a different device.</span>
                    </div>
                </div>
            </ng-template>
            </ng-container>

            <ng-container *ngIf="selectedDeviceAnalyticsView === 'topDevices'">
                <div class="top-devices-heading">
                    <div>
                        <span class="top-devices-eyebrow">vHUB Network Intelligence</span>
                        <h4>Top Devices <span class="top-devices-heading-metric">{{getTopDevicesMetricConfig().label}}</span></h4>
                        <p>Compare {{getTopDevicesMetricConfig().label | lowercase}} across vHUB devices during the selected period.</p>
                    </div>
                    <div class="top-devices-heading-meta" aria-label="Current analytics settings">
                        <span>{{getSelectedTopDevicesRangeLabel()}}</span>
                        <span>Top {{topDevicesTopN}}</span>
                        <span>Server aggregated</span>
                    </div>
                </div>

                <mat-tab-group animationDuration="0ms" class="lane-analytics-tabs" [selectedIndex]="selectedTopDevicesRange"
                    (selectedIndexChange)="onTopDevicesRangeChange($event)">
                    <mat-tab *ngFor="let range of topDevicesRanges" [label]="range.label"></mat-tab>
                </mat-tab-group>

                <div class="top-devices-custom-range" *ngIf="!topDevicesRanges[selectedTopDevicesRange]?.range">
                    <label>From <input type="datetime-local" [(ngModel)]="topDevicesFrom" /></label>
                    <label>To <input type="datetime-local" [(ngModel)]="topDevicesTo" /></label>
                    <button type="button" class="mini-btn" [disabled]="!topDevicesFrom || !topDevicesTo"
                        (click)="onTopDevicesFilterChange()">Apply</button>
                </div>

                <div class="top-devices-metric-nav" role="group" aria-label="Analytics metric">
                    <div class="top-devices-metric-nav-copy">
                        <strong>Analyze by metric</strong>
                        <span>Switch the complete dashboard without losing your range or filters.</span>
                    </div>
                    <div class="top-devices-metric-options">
                        <button type="button" *ngFor="let metric of topDevicesMetricOptions"
                            [class.active]="selectedTopDevicesMetric === metric.key"
                            [attr.aria-pressed]="selectedTopDevicesMetric === metric.key"
                            (click)="selectTopDevicesMetric(metric.key)">
                            <span class="top-devices-metric-dot" aria-hidden="true"></span>
                            {{metric.label}}
                        </button>
                    </div>
                </div>

                <div class="top-devices-controls">
                    <div class="top-devices-control-cluster">
                        <label>Show
                            <select [(ngModel)]="topDevicesTopN" (change)="onTopDevicesFilterChange()">
                                <option [ngValue]="5">Top 5</option>
                                <option [ngValue]="10">Top 10</option>
                                <option [ngValue]="20">Top 20</option>
                            </select>
                        </label>
                        <label>Sort by
                            <select [(ngModel)]="topDevicesSort" (change)="onTopDevicesFilterChange()">
                                <option *ngFor="let option of topDevicesSortOptions" [value]="option.value">{{option.label}}</option>
                            </select>
                        </label>
                        <label>Order
                            <select [(ngModel)]="topDevicesOrder" (change)="onTopDevicesFilterChange()">
                                <option value="desc">Descending</option>
                                <option value="asc">Ascending</option>
                            </select>
                        </label>
                    </div>
                    <label class="top-devices-vce-filter">Registered VCE
                        <div class="lane-analytics-device-picker">
                            <input type="search" [(ngModel)]="topDevicesVceSearchText"
                                placeholder="Search registered VCE"
                                aria-label="Search registered VCE by name or MAC address"
                                autocomplete="off"
                                (focus)="onTopDevicesVceSearchFocus()"
                                (blur)="onTopDevicesVceSearchBlur()"
                                (input)="onTopDevicesVceSearchInput()" />
                            <span class="lane-analytics-picker-arrow" aria-hidden="true">&#9662;</span>
                            <div class="lane-analytics-device-options" *ngIf="topDevicesVcePickerOpen">
                                <button type="button" class="top-devices-all-vces"
                                    [class.active]="!topDevicesAppliedSearch"
                                    (mousedown)="$event.preventDefault(); selectTopDevicesRegisteredVce()">
                                    <strong>All registered VCEs</strong>
                                    <small>Clear device filter</small>
                                </button>
                                <button type="button"
                                    *ngFor="let device of getFilteredTopDevicesRegisteredVces(); trackBy: trackByTopDevicesRegisteredVce"
                                    [class.active]="device.mac.toLowerCase() === topDevicesAppliedSearch.toLowerCase()"
                                    (mousedown)="$event.preventDefault(); selectTopDevicesRegisteredVce(device)">
                                    <strong>{{device.name}}</strong>
                                    <small>{{device.mac}}</small>
                                </button>
                                <div class="lane-analytics-device-options-empty"
                                    *ngIf="!getFilteredTopDevicesRegisteredVces().length">
                                    No matching registered VCEs
                                </div>
                            </div>
                        </div>
                    </label>
                    <label class="top-devices-rows-control">Rows
                        <select [(ngModel)]="topDevicesPageSize" (change)="onTopDevicesFilterChange()">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="25">25</option>
                            <option [ngValue]="50">50</option>
                        </select>
                    </label>
                </div>

                <div class="lane-analytics-state lane-analytics-loading-state" *ngIf="topDevicesLoading">
                    <span class="lane-analytics-spinner" aria-hidden="true"></span>
                    <div><strong>Loading {{getTopDevicesMetricConfig().label}}...</strong></div>
                </div>
                <div class="lane-analytics-state lane-analytics-error-state" *ngIf="topDevicesError && !topDevicesLoading">
                    <div><strong>{{topDevicesError}}</strong><span>Please retry the request.</span></div>
                    <button type="button" class="mini-btn" (click)="retryTopDevices()">Retry</button>
                </div>
                <div class="lane-analytics-state" *ngIf="!topDevicesLoading && !topDevicesError && !topDevicesData">
                    <div><strong>Select a time range to view top device consumption.</strong></div>
                </div>

                <ng-container *ngIf="topDevicesData && !topDevicesLoading && !topDevicesError">
                    <div class="top-devices-kpis">
                        <div class="top-devices-kpi-card" *ngFor="let kpi of topDevicesData.metric_kpis; let i = index">
                            <div class="top-devices-kpi-label">
                                <span>{{kpi.label}}</span>
                                <i aria-hidden="true">{{i + 1}}</i>
                            </div>
                            <strong>{{formatTopDevicesKpi(kpi)}}</strong>
                            <small>{{getTopDevicesMetricConfig().label}} summary</small>
                        </div>
                    </div>

                    <div class="lane-analytics-state" *ngIf="!getTopDevicesDeviceCount()">
                        <div><strong>No analytics data available for the selected metric and time range.</strong></div>
                    </div>

                    <ng-container *ngIf="getTopDevicesDeviceCount()">
                        <div class="top-devices-graph-grid">
                            <div class="lane-analytics-graph" *ngFor="let graph of topDevicesGraphs; trackBy: trackByLaneAnalyticsGraph">
                                <div class="top-devices-chart-head">
                                    <div><span>{{graph.type === 'line' ? 'Trend' : 'Ranking'}}</span><h6>{{graph.title}}</h6></div>
                                    <em>{{getTopDevicesMetricConfig().unit}}</em>
                                </div>
                                <div class="lane-analytics-chart-body">
                                    <canvas #topDevicesCanvas></canvas>
                                </div>
                            </div>
                        </div>

                        <div class="top-devices-table-head">
                            <div>
                                <span class="top-devices-table-eyebrow">Device details</span>
                                <h5>{{getTopDevicesMetricConfig().rankingTitle}}</h5>
                            </div>
                            <span class="top-devices-result-count">{{topDevicesSkip + 1}}-{{getTopDevicesPageEnd()}} of {{getTopDevicesTotal()}}</span>
                        </div>
                        <div class="table-shell top-devices-table-shell">
                            <table class="overlay-table top-devices-table">
                                <thead><tr>
                                    <th>Rank</th><th>Device Name</th><th>MAC</th>
                                    <th *ngFor="let column of getTopDevicesTableColumns()">{{column.label}}</th>
                                </tr></thead>
                                <tbody>
                                    <tr *ngFor="let device of getTopDevicesTableItems()" (click)="drillDownTopDevice(device)"
                                        tabindex="0" (keyup.enter)="drillDownTopDevice(device)">
                                        <td><span class="top-device-rank">#{{device.rank}}</span></td>
                                        <td><button type="button" class="top-device-link" (click)="$event.stopPropagation(); drillDownTopDevice(device)">{{getTopDevicesDeviceLabel(device)}}</button></td>
                                        <td><code>{{device.mac}}</code></td>
                                        <td *ngFor="let column of getTopDevicesTableColumns()">
                                            {{formatTopDevicesTableValue(device, column)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="top-devices-pagination">
                            <span>Page {{getTopDevicesCurrentPage()}} of {{getTopDevicesPageCount()}}</span>
                            <button type="button" class="mini-btn secondary" [disabled]="topDevicesSkip === 0" (click)="previousTopDevicesPage()">Previous</button>
                            <button type="button" class="mini-btn secondary" [disabled]="getTopDevicesPageEnd() >= getTopDevicesTotal()" (click)="nextTopDevicesPage()">Next</button>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </section>

        <section class="overlay-section" *ngIf="false && selectedOverlayPlusTab === 3">
            <div class="section-head">
                <h3>Restore / Import</h3>
            </div>
            <div class="restore-import-panel">
                <div class="restore-block">
                    <div class="block-title">Restore From Backup <small>&mdash; timestamped backups created automatically on each load</small></div>
                    <button type="button" class="dpc-action-btn refresh-dpc-btn">Load / Refresh</button>
                    <div class="table-shell restore-table-shell">
                        <table class="overlay-table restore-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Backup File</th>
                                    <th>Timestamp</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let backup of backupRows; let backupIndex = index">
                                    <td>{{backupIndex + 1}}</td>
                                    <td><span class="backup-file">{{backup.file}}</span></td>
                                    <td>{{backup.timestamp}}</td>
                                    <td class="actions-cell">
                                        <button type="button" class="table-btn table-btn-neutral">Load to Editor</button>
                                        <button type="button" class="table-btn table-btn-delete">Restore Now</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="restore-block import-json-block">
                    <div class="block-title">Import JSON <small>&mdash; paste a single peer object or a full authorized_peers.json</small></div>
                    <div class="import-grid">
                        <div class="import-side">
                            <label class="form-field">
                                <span>Import Mode</span>
                                <select [(ngModel)]="restoreImportModel.importMode">
                                    <option>Merge -- add / update peers</option>
                                    <option>Replace all peers</option>
                                </select>
                            </label>
                            <button type="button" class="save-btn import-btn">Import</button>
                            <button type="button" class="cancel-btn import-btn">Clear</button>
                        </div>
                        <label class="form-field import-editor">
                            <span>Paste JSON here</span>
                            <textarea [(ngModel)]="restoreImportModel.pasteJson"></textarea>
                        </label>
                    </div>
                </div>

                <div class="restore-block vhub-swing-block">
                    <div class="block-title">vHUB Swing <small>&mdash; update all remote_addr entries to this vHub's server_url then save &amp; apply</small></div>
                    <div class="swing-row">
                        <label class="form-field swing-input">
                            <span>New remote_addr</span>
                            <input type="text" [(ngModel)]="restoreImportModel.newRemoteAddr" />
                        </label>
                        <button type="button" class="dpc-action-btn refresh-dpc-btn">Fill from DPC</button>
                        <button type="button" class="save-btn swing-save-btn">Update All &amp; Save</button>
                    </div>
                </div>

                <div class="restore-block authorized-editor-block">
                    <div class="authorized-head">
                        <div>
                            <h4>/etc/rrt-midlay/authorized_peers.json</h4>
                            <div class="section-subhead">Editing live &mdash; Save &amp; Apply writes to device and reloads auth</div>
                        </div>
                        <div class="authorized-actions">
                            <button type="button" class="dpc-action-btn refresh-dpc-btn">Download</button>
                            <button type="button" class="save-btn">Save &amp; Apply</button>
                        </div>
                    </div>
                    <textarea class="authorized-json-editor" [(ngModel)]="restoreImportModel.authorizedPeersJson"></textarea>
                </div>
            </div>
        </section>
    </ng-container>

    <ng-template #deviceOverlayView>
        <ng-container *ngIf="selectedVceOverlayPlusTab === 0">
        <section class="overlay-section">
            <div class="section-head">
                <h3>Interface</h3>
        </div>
            <div class="table-shell">
                <table class="overlay-table">
                    <thead>
                        <tr>
                            <th>Iface</th>
                            <th>SDWAN Link</th>
                            <th>Tunnel IP</th>
                            <th>Server URL</th>
                            <th>DPC Gateway</th>
                            <th>IP4 Table</th>
                            <th>MTU</th>
                            <th>MaxPkt</th>
                            <th>Distribution</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of interfaceRows">
                            <td><span class="mono-chip">{{row.iface}}</span></td>
                            <td>{{row.sdwan_link}}</td>
                            <td>
                                <span class="mono-chip">{{row.tunnel_ip}}</span>
                                <div *ngIf="row.dmz_ip"><strong>DMZ IP:</strong> {{row.dmz_ip}}</div>
                            </td>
                            <td>{{row.server_url}}</td>
                            <td><span class="mono-chip">{{row.dpc_gateway}}</span></td>
                            <td>{{row.ip4_table}}</td>
                            <td>{{row.mtu}}</td>
                            <td>{{row.max_packet_size}}</td>
                            <td>{{row.distribution}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <section class="overlay-section">
            <div class="section-head">
                <h3>Connection</h3>
            </div>
            <div class="table-shell">
                <table class="overlay-table">
                    <thead>
                        <tr>
                            <th>SDWAN Link</th>
                            <th>VHUB Endpoint</th>
                            <th>Assigned IPs</th>
                            <th>Iface / Lane</th>
                            <th>Ulay / Transport / Lane Assurance</th>
                            <th>Weight TX/RX</th>
                            <th>WAN ID</th>
                            <th>Uptime</th>
                            <th>State</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of connectionRows">
                            <td><span class="mono-chip">{{row.sdwan_link}}</span></td>
                            <td>{{row.endpoint}}</td>
                            <td>{{row.assigned_ips}}</td>
                            <td>{{row.link_lane}}</td>
                            <td>
                                <div class="assurance" *ngIf="row.assuranceLines?.length">
                                    <div *ngFor="let line of row.assuranceLines">{{line}}</div>
                                </div>
                            </td>
                            <td>{{row.weight || '-'}}</td>
                            <td>{{row.wan_id}}</td>
                            <td>{{row.uptime}}</td>
                            <td>
                                <span *ngIf="row.state" class="state-pill" [ngClass]="getStateClass(row.state)">
                                    {{getStateLabel(row.state)}}
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="!connectionRows.length">
                            <td colspan="9" class="text-center">No Overlay Plus data available.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        </ng-container>

        <section class="overlay-section" *ngIf="selectedVceOverlayPlusTab === 1">
            <div class="section-head">
                <h3>Device Analytics</h3>
            </div>
            <mat-tab-group animationDuration="0ms" class="lane-analytics-tabs" [selectedIndex]="selectedLaneAnalyticsRange"
                (selectedIndexChange)="onLaneAnalyticsRangeChange($event)">
                <mat-tab label="Last 4 Hrs"></mat-tab>
                <mat-tab label="Last 24 Hrs"></mat-tab>
                <mat-tab label="Last 7 Days"></mat-tab>
                <mat-tab label="This Month"></mat-tab>
                <mat-tab label="Last Month"></mat-tab>
            </mat-tab-group>
            <ng-container *ngTemplateOutlet="laneAnalyticsTimezonePicker"></ng-container>

            <div class="provisioning-alert" *ngIf="laneAnalyticsLoading">Loading Device Analytics...</div>
            <div class="add-overlay-error" *ngIf="laneAnalyticsError">{{laneAnalyticsError}}</div>

            <ng-container *ngIf="getLaneAnalyticsRows() as laneRows">
                <ng-container *ngIf="!laneAnalyticsLoading && laneRows.length; else noVceLaneAnalyticsData">
                    <div class="lane-analytics-grid">
                        <div class="table-shell lane-analytics-table-shell">
                            <table class="overlay-table lane-analytics-table">
                                <caption>SDWAN, Overlay Plus, Device Analytics:</caption>
                                <thead>
                                    <tr>
                                        <th>Underlays and Lanes</th>
                                        <th>FEC</th>
                                        <th>Mode</th>
                                        <th>Q-Class</th>
                                        <th>TX Mbps</th>
                                        <th>TX Bytes</th>
                                        <th>RX Mbps</th>
                                        <th>RX Bytes</th>
                                        <th>Loss %</th>
                                        <th>Avg Latency</th>
                                        <th>P90 Latency</th>
                                        <th>Jitter</th>
                                        <th>MOS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="lane-link-row" *ngFor="let linkRow of getLaneAnalyticsTableLinkRows()">
                                        <td><span class="mono-chip lane-link-chip">{{linkRow.linkLabel}}</span></td>
                                        <td>-</td>
                                        <td>{{linkRow.mode}}</td>
                                        <td>-</td>
                                        <td>{{linkRow.txMbps | number:'1.0-3'}}</td>
                                        <td>{{formatBytes(linkRow.txBytes)}}</td>
                                        <td>{{linkRow.rxMbps | number:'1.0-3'}}</td>
                                        <td>{{formatBytes(linkRow.rxBytes)}}</td>
                                        <td>{{linkRow.lossPct | number:'1.0-2'}}</td>
                                        <td>{{linkRow.decodeLatencyAvg}}ms</td>
                                        <td>{{linkRow.decodeLatencyP90}}ms</td>
                                        <td>{{linkRow.jitter}}ms</td>
                                        <td>{{linkRow.mos}}</td>
                                    </tr>
                                    <tr *ngFor="let row of laneRows">
                                        <td><span class="mono-chip lane-value-chip">{{row.laneLabel}}</span></td>
                                        <td>{{row.ratio}}</td>
                                        <td>{{row.mode}}</td>
                                        <td>{{row.qClass}}</td>
                                        <td>{{row.txMbps | number:'1.0-3'}}</td>
                                        <td>{{formatBytes(row.txBytes)}}</td>
                                        <td>{{row.rxMbps | number:'1.0-3'}}</td>
                                        <td>{{formatBytes(row.rxBytes)}}</td>
                                        <td>{{row.lossPct}}</td>
                                        <td>{{row.decodeLatencyAvg}}ms</td>
                                        <td>{{row.decodeLatencyP90}}ms</td>
                                        <td>{{row.jitter}}ms</td>
                                        <td>{{row.mos}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="lane-analytics-graph-grid">
                            <div class="lane-analytics-graph" *ngFor="let graph of laneAnalyticsGraphs" (dblclick)="openLaneAnalyticsChart(graph, expandedLaneChart)" title="Double-click to expand">
                                <h6>{{graph.title}}</h6>
                                <div class="lane-analytics-legend" *ngIf="graph.legendGroups?.length">
                                    <div class="lane-analytics-legend-group" *ngFor="let group of graph.legendGroups">
                                        <div class="lane-analytics-legend-row" *ngIf="group.linkItems?.length">
                                            <div class="lane-analytics-legend-items">
                                            <button type="button" class="lane-analytics-legend-item" *ngFor="let item of group.linkItems"
                                                [class.hidden]="item.hidden"
                                                [attr.aria-pressed]="!item.hidden"
                                                [attr.aria-label]="(item.hidden ? 'Show ' : 'Hide ') + item.laneLabel"
                                                (click)="toggleLaneAnalyticsSeries(graph, item)">
                                                <span class="lane-analytics-legend-swatch" [style.background]="item.color"></span>
                                                {{item.laneLabel}}
                                            </button>
                                            </div>
                                        </div>
                                        <div class="lane-analytics-legend-row" *ngIf="group.laneItems?.length">
                                            <div class="lane-analytics-legend-items">
                                            <button type="button" class="lane-analytics-legend-item" *ngFor="let item of group.laneItems"
                                                [class.hidden]="item.hidden"
                                                [attr.aria-pressed]="!item.hidden"
                                                [attr.aria-label]="(item.hidden ? 'Show ' : 'Hide ') + item.laneLabel"
                                                (click)="toggleLaneAnalyticsSeries(graph, item)">
                                                <span class="lane-analytics-legend-swatch" [style.background]="item.color"></span>
                                                {{item.laneLabel}}
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="lane-analytics-chart-body">
                                    <canvas #laneAnalyticsCanvas tabindex="0" (keydown.enter)="openLaneAnalyticsChart(graph, expandedLaneChart)" aria-label="Chart. Double-click or press Enter to expand." title="Double-click to expand"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noVceLaneAnalyticsData>
                <div class="empty-state" *ngIf="!laneAnalyticsLoading">No Device Analytics data available.</div>
            </ng-template>
        </section>
    </ng-template>
</div>

<ng-template #emptyState>
    <div class="empty-state">
        No Overlay Plus interface data available for this device.
    </div>
</ng-template>

<ng-template #vceAddOverlayDialog>
    <div class="vce-add-overlay-dialog">
        <h2>Add New Overlay Plus Connection</h2>
        <label class="paste-label" for="vce-add-provisioning-block">
            <strong>Paste Provisioning Block</strong>
            <span>&mdash; UI Block from vHUB Overlay Plus &rarr; Get Provisioning</span>
        </label>
        <textarea id="vce-add-provisioning-block" [(ngModel)]="vceAddProvisioningBlock" spellcheck="false"></textarea>
        <div class="field-error add-overlay-error" *ngIf="vceAddProvisioningError">{{vceAddProvisioningError}}</div>
        <div class="dialog-actions">
            <button type="button" class="save-btn validate-overlay-btn" (click)="validateVceAddOverlayProvisioning()">Validate</button>
            <button type="button" class="cancel-btn" mat-dialog-close>Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #vceOverlayEditDialog>
    <div class="vce-overlay-edit-dialog">
        <h2>Edit &mdash; {{vceEditModel.title}}</h2>
        <p class="edit-note">Read-only fields are set by the vHUB provisioning block. FEC lanes can be edited locally &mdash; a new user config file will be saved.</p>

        <div class="readonly-title">Provisioned Settings (read-only)</div>
        <table class="readonly-settings">
            <tbody>
                <tr>
                    <th>Device Model</th>
                    <td>{{vceEditModel.readOnly.deviceModel}}</td>
                    <th>Remote Addr</th>
                    <td>{{vceEditModel.readOnly.remoteAddr}}</td>
                </tr>
                <tr>
                    <th>DPC IP</th>
                    <td>{{vceEditModel.readOnly.dpcIp}}</td>
                    <th>DPC Gateway</th>
                    <td>{{vceEditModel.readOnly.dpcGateway}}</td>
                </tr>
                <tr>
                    <th>MTU</th>
                    <td>{{vceEditModel.readOnly.mtu}}</td>
                    <th>Keepalive</th>
                    <td>{{vceEditModel.readOnly.keepalive}}</td>
                </tr>
            </tbody>
        </table>

        <hr />

        <div class="edit-section-title">Multipath Link Management</div>
        <div class="link-header">
            <div></div>
            <div *ngFor="let link of vceEditModel.links; let vceLinkIndex = index">
                <p>{{link.label}}</p>
                <div class="link-picker">
                    <button type="button" class="btn blue" (click)="toggleLinkPicker('vce-edit-link-' + vceLinkIndex)">{{link.name}} ▾</button>
                    <div class="link-picker-menu" *ngIf="openLinkPickerKey === 'vce-edit-link-' + vceLinkIndex">
                        <button type="button" *ngFor="let option of linkSelectOptions" (click)="setLinkPickerValue(link, 'name', option)">{{option}}</button>
                        <input type="text" [(ngModel)]="customLinkValues['vce-edit-link-' + vceLinkIndex]" placeholder="type link id..." />
                        <button type="button" class="link-set-btn" (click)="setCustomLinkPickerValue(link, 'name', 'vce-edit-link-' + vceLinkIndex)">Set</button>
                        <button type="button" class="link-clear-btn" (click)="clearLinkPickerValue(link, 'name')">[Clear]</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="vce-grid">
            <label for="vce-edit-mode">Mode</label>
            <select id="vce-edit-mode" [(ngModel)]="vceEditModel.mode">
                <option>Route</option>
                <option>Bridge</option>
            </select>
            <div></div>
            <div></div>
            <div></div>

            <div></div>
            <strong *ngFor="let link of vceEditModel.links; let linkIndex = index">
                {{isPeerDetailLinkSet(link) ? link.name : (linkIndex < 2 ? 'Link ' + (linkIndex + 1) : '')}}
            </strong>

            <div class="field-label">Transport</div>
            <ng-container *ngFor="let link of vceEditModel.links; let linkIndex = index">
                <select *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else vceEditEmptyLinkCell" [(ngModel)]="link.transport">
                    <option *ngFor="let option of transportProtocolOptions" [value]="option.value">{{option.label}}</option>
                </select>
            </ng-container>

            <div class="field-label">Path</div>
            <ng-container *ngFor="let link of vceEditModel.links; let linkIndex = index">
                <input *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else vceEditEmptyLinkCell" [(ngModel)]="link.path" [placeholder]="linkIndex === 0 ? 'wan' : (linkIndex === 1 ? 'wan2' : link.name)" />
            </ng-container>

            <div class="field-label">Weight <small>TX / RX</small></div>
            <ng-container *ngFor="let link of vceEditModel.links; let linkIndex = index">
                <div class="pair" *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else vceEditEmptyLinkCell">
                    <input type="number" [(ngModel)]="link.tx" placeholder="TX" />
                    <input type="number" [(ngModel)]="link.rx" placeholder="RX" />
                </div>
            </ng-container>

            <div class="field-label">Timeout (ms)</div>
            <ng-container *ngFor="let link of vceEditModel.links; let linkIndex = index">
                <input *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else vceEditEmptyLinkCell" type="number" [(ngModel)]="link.timeout" placeholder="3200" />
            </ng-container>

            <div class="field-label">Flapcheck (ms)</div>
            <ng-container *ngFor="let link of vceEditModel.links; let linkIndex = index">
                <input *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else vceEditEmptyLinkCell" type="number" [(ngModel)]="link.flapcheck" placeholder="30000" />
            </ng-container>

            <label class="strong-label" for="vce-edit-distribution">Distribution</label>
            <select id="vce-edit-distribution" [(ngModel)]="vceEditModel.distribution">
                <option *ngFor="let option of distributionModeOptions" [value]="option.value">{{option.label}}</option>
            </select>
            <div></div>
            <div></div>
            <div></div>

            <label class="strong-label" for="vce-edit-max-packet-size">Max Packet Size</label>
            <input id="vce-edit-max-packet-size" type="number" [(ngModel)]="vceEditModel.maxPacketSize" />
            <div></div>
            <div></div>
            <div></div>
        </div>

        <ng-template #vceEditEmptyLinkCell>
            <div class="empty-link-cell"></div>
        </ng-template>

        <div class="tuning-title">Performance Tuning <span>(per-team transport knobs)</span></div>
        <div class="tuning-grid">
            <div class="field">
                <label for="vce-edit-rseq-hold">rseq_hold_ms <span>(0=off)</span></label>
                <input id="vce-edit-rseq-hold" type="number" [(ngModel)]="vceEditModel.rseqHoldMs" placeholder="60" />
            </div>
            <div class="field">
                <label for="vce-edit-rseq-thin-acks">rseq_thin_acks <span>(0=off)</span></label>
                <input id="vce-edit-rseq-thin-acks" type="number" [(ngModel)]="vceEditModel.rseqThinkAcks" placeholder="6" />
            </div>
            <div class="field">
                <label for="vce-edit-maxblocks">maxblocks</label>
                <input id="vce-edit-maxblocks" type="number" [(ngModel)]="vceEditModel.fecMaxBlocks" placeholder="32" />
            </div>
            <div class="field">
                <label for="vce-edit-fec-group-hold">fec_group_hold</label>
                <input id="vce-edit-fec-group-hold" type="number" [(ngModel)]="vceEditModel.fecGroupHold" placeholder="0" />
            </div>
            <div class="field">
                <label for="vce-edit-fec-group-hold-depth">fec_group_hold_depth <span>(blank=auto)</span></label>
                <input id="vce-edit-fec-group-hold-depth" [(ngModel)]="vceEditModel.fecGroupHoldDepth" placeholder="auto" />
            </div>
        </div>

        <hr />

        <div class="fec-default">
            <strong>Default FEC (Orig:Dupes)</strong>
            <input [(ngModel)]="vceEditModel.defaultFec" placeholder="10:0" />
            <button type="button" class="btn muted" (click)="addVceEditFecLane()">+ Add Lane</button>
        </div>

        <div class="fec-lane vce-edit-fec-lane" *ngFor="let lane of vceEditModel.fecLanes; let laneIndex = index">
            <strong>{{lane.lane}}</strong>
            <div>
                <small>Orig:Dupes</small>
                <input [(ngModel)]="lane.origDupes" placeholder="1:3" />
            </div>
            <div>
                <small>Mode</small>
                <select [(ngModel)]="lane.mode">
                    <option *ngFor="let option of fecLaneModeOptions" [value]="option.value">{{option.label}}</option>
                </select>
            </div>
            <button type="button" class="btn get">Select Q-Class</button>
            <span class="qos-selected">{{getVceEditQosLabel(lane)}}</span>
            <button type="button" class="btn danger" (click)="removeVceEditFecLane(laneIndex)">×</button>
        </div>

        <div class="actions">
            <button type="button" class="btn save" [disabled]="overlayPlusCrudLoading" (click)="saveVceOverlayEdit()">
                <span class="btn-spinner" *ngIf="overlayPlusCrudLoading"></span>
                {{overlayPlusCrudLoading ? 'Applying...' : 'Apply & Restart'}}
            </button>
            <button type="button" class="btn muted" [disabled]="overlayPlusCrudLoading" mat-dialog-close>Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #peerShowDialog>
    <div class="peer-show-dialog modal-shell">
        <div class="modal-card">
            <h1>Peer: {{peerDetailModel.mac || '-'}}</h1>

            <p class="provisioned">{{peerDetailModel.provisioned || 'Provisioned: -'}}</p>

            <div class="grid">
                <div class="field client-type-field">
                    <label for="peer-detail-client-device-type">Client Device Type</label>
                    <select id="peer-detail-client-device-type" [(ngModel)]="peerDetailModel.clientDeviceType">
                        <option *ngFor="let option of clientDeviceTypeOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                </div>

                <div class="note seed-note-field">
                    Changing this seeds the Performance Tuning fields with the platform defaults.
                    Operator-edited values are preserved across save/load.
                </div>

                <div class="field mac-field">
                    <label for="peer-detail-mac">MAC</label>
                    <input id="peer-detail-mac" [(ngModel)]="peerDetailModel.mac" readonly title="MAC cannot be changed in edit mode" />
                </div>

                <div class="field hostname-field">
                    <label for="peer-detail-hostname">Hostname</label>
                    <input id="peer-detail-hostname" [(ngModel)]="peerDetailModel.hostname" />
                </div>

                <div class="field dpc-allowed-field">
                    <label for="peer-detail-dpc-allowed">DPC Allowed</label>
                    <select id="peer-detail-dpc-allowed" [(ngModel)]="peerDetailModel.dpcAllowed">
                        <option *ngFor="let dpc of dpcServiceRows" [value]="dpc.name">{{dpc.name}} ({{dpc.server_url}})</option>
                    </select>
                </div>

                <div class="field encrypt-field">
                    <label for="peer-detail-encrypt">Encrypt</label>
                    <select id="peer-detail-encrypt" [(ngModel)]="peerDetailModel.encrypt">
                        <option>On</option>
                        <option>Off</option>
                    </select>
                </div>

                <div class="field psk-grid-field">
                    <label for="peer-detail-psk">PSK</label>
                    <input id="peer-detail-psk" [type]="showPeerPsk ? 'text' : 'password'" [(ngModel)]="peerDetailModel.psk" />
                </div>

                <div class="psk-button-group">
                    <button type="button" class="btn muted" (click)="regeneratePeerPsk()">Regenerate</button>
                    <button type="button" class="btn muted" [disabled]="peerPskLoading" (click)="togglePeerPsk()">{{peerPskLoading ? 'Loading...' : (showPeerPsk ? 'Hide' : 'Show')}}</button>
                </div>

                <div class="field dpc-ip-field">
                    <label for="peer-detail-dpc-ip">DPC IP <span>(auto or CIDR)</span></label>
                    <input id="peer-detail-dpc-ip" [(ngModel)]="peerDetailModel.dpcIp" placeholder="auto" />
                </div>

                <div class="field wan-id-field">
                    <label for="peer-detail-wan-id">WAN ID <span>(optional)</span></label>
                    <input id="peer-detail-wan-id" [(ngModel)]="peerDetailModel.wanId" placeholder="100001" />
                </div>

                <div class="field wan-subnet-field">
                    <label for="peer-detail-wan-subnet">WAN Subnet <span>(space-separated CIDRs)</span></label>
                    <input id="peer-detail-wan-subnet" [(ngModel)]="peerDetailModel.wanSubnet" placeholder="192.168.100.0/24" />
                </div>

                <div class="field dmz-ips-field">
                    <label for="peer-detail-dmz-ips">DMZ IPs <span>(space-separated CIDRs)</span></label>
                    <input id="peer-detail-dmz-ips" [(ngModel)]="peerDetailModel.dmzIps" />
                </div>

                <div class="field dmz-subnets-field">
                    <label for="peer-detail-dmz-subnets">DMZ Subnets <span>(space-separated CIDRs)</span></label>
                    <input id="peer-detail-dmz-subnets" [(ngModel)]="peerDetailModel.dmzSubnets" />
                </div>
            </div>

            <hr />

            <h2>VCE Provisioning <span>(applied to device at install time)</span></h2>

            <div class="link-header">
                <div></div>

                <div *ngFor="let link of peerDetailModel.links; let peerLinkIndex = index">
                    <p>{{link.label}}</p>
                    <div class="link-picker">
                        <button type="button" class="btn blue" (click)="toggleLinkPicker('peer-link-' + peerLinkIndex)">{{link.name}} ▾</button>
                        <div class="link-picker-menu" *ngIf="openLinkPickerKey === 'peer-link-' + peerLinkIndex">
                            <button type="button" *ngFor="let option of linkSelectOptions" (click)="setLinkPickerValue(link, 'name', option)">{{option}}</button>
                            <input type="text" [(ngModel)]="customLinkValues['peer-link-' + peerLinkIndex]" placeholder="type link id..." />
                            <button type="button" class="link-set-btn" (click)="setCustomLinkPickerValue(link, 'name', 'peer-link-' + peerLinkIndex)">Set</button>
                            <button type="button" class="link-clear-btn" (click)="clearLinkPickerValue(link, 'name')">[Clear]</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vce-grid">
                <label for="peer-detail-mode">Mode</label>
                <select id="peer-detail-mode" [(ngModel)]="peerDetailModel.mode">
                    <option>Route</option>
                    <option>Bridge</option>
                </select>

                <div></div>
                <div></div>
                <div></div>

                <div></div>
                <strong *ngFor="let link of peerDetailModel.links; let linkIndex = index">
                    {{isPeerDetailLinkSet(link) ? link.name : (linkIndex < 2 ? 'Link ' + (linkIndex + 1) : '')}}
                </strong>

                <div class="field-label">Transport</div>
                <ng-container *ngFor="let link of peerDetailModel.links; let linkIndex = index">
                    <select *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else emptyLinkCell" [(ngModel)]="link.transport">
                        <option *ngFor="let option of transportProtocolOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                </ng-container>

                <div class="field-label">Path</div>
                <ng-container *ngFor="let link of peerDetailModel.links; let linkIndex = index">
                    <input *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else emptyLinkCell" [(ngModel)]="link.path" [placeholder]="linkIndex === 0 ? 'wan' : (linkIndex === 1 ? 'wan2' : link.name)" />
                </ng-container>

                <div class="field-label">Weight <small>TX / RX</small></div>
                <ng-container *ngFor="let link of peerDetailModel.links; let linkIndex = index">
                    <div class="pair" *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else emptyLinkCell">
                        <input type="number" [(ngModel)]="link.tx" placeholder="TX" />
                        <input type="number" [(ngModel)]="link.rx" placeholder="RX" />
                    </div>
                </ng-container>

                <div class="field-label">Timeout (ms)</div>
                <ng-container *ngFor="let link of peerDetailModel.links; let linkIndex = index">
                    <input *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else emptyLinkCell" type="number" [(ngModel)]="link.timeout" placeholder="3200" />
                </ng-container>

                <div class="field-label">Flapcheck (ms)</div>
                <ng-container *ngFor="let link of peerDetailModel.links; let linkIndex = index">
                    <input *ngIf="linkIndex < 2 || isPeerDetailLinkSet(link); else emptyLinkCell" type="number" [(ngModel)]="link.flapcheck" placeholder="30000" />
                </ng-container>

                <strong>Distribution</strong>
                <select [(ngModel)]="peerDetailModel.distribution">
                    <option *ngFor="let option of distributionModeOptions" [value]="option.value">{{option.label}}</option>
                </select>
                <div></div>
                <div></div>
                <div></div>

                <strong>Max Packet Size</strong>
                <input type="number" [(ngModel)]="peerDetailModel.maxPacketSize" />
                <div></div>
                <div></div>
                <div></div>
            </div>

            <ng-template #emptyLinkCell>
                <div class="empty-link-cell"></div>
            </ng-template>

            <hr />

            <h2>FEC Settings <span>(Editable)</span></h2>

            <div class="fec-default">
                <strong>Default FEC (Orig:Dupes)</strong>
                <input [(ngModel)]="peerDetailModel.defaultFec" placeholder="10:0" />
                <button type="button" class="btn muted" (click)="addPeerFecLane()">+ Add Lane</button>
            </div>

            <div class="fec-lane" *ngFor="let lane of peerFecLanes; let laneIndex = index">
                <strong>{{lane.lane}}</strong>

                <div>
                    <small>Orig:Dupes</small>
                    <input [(ngModel)]="lane.origDupes" placeholder="1:3" />
                </div>

                <div>
                    <small>Mode</small>
                    <select [(ngModel)]="lane.mode">
                        <option *ngFor="let option of fecLaneModeOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                </div>

                <div>
                    <small>Steer Class</small>
                    <input [(ngModel)]="lane.steer" placeholder="{{laneIndex + 1}}" />
                </div>

                <button type="button" class="btn danger" (click)="removePeerFecLane(laneIndex)">×</button>
            </div>

            <hr />

            <h2>Performance Tuning <span>(per-team transport knobs)</span></h2>

            <div class="tuning-grid">
                <div class="field">
                    <label for="peer-detail-rseq-hold">rseq_hold_ms <span>(0=off)</span></label>
                    <input id="peer-detail-rseq-hold" type="number" [(ngModel)]="peerDetailModel.rseqHoldMs" placeholder="60" />
                </div>

                <div class="field">
                    <label for="peer-detail-rseq-thin-acks">rseq_thin_acks <span>(0=off)</span></label>
                    <input id="peer-detail-rseq-thin-acks" type="number" [(ngModel)]="peerDetailModel.rseqThinkAcks" placeholder="6" />
                </div>

                <div class="field">
                    <label for="peer-detail-maxblocks">maxblocks</label>
                    <input id="peer-detail-maxblocks" type="number" [(ngModel)]="peerDetailModel.fecMaxBlocks" placeholder="8" />
                </div>

                <div class="field">
                    <label for="peer-detail-fec-group-hold">fec_group_hold</label>
                    <input id="peer-detail-fec-group-hold" type="number" [(ngModel)]="peerDetailModel.fecGroupHold" placeholder="0" />
                </div>

                <div class="field">
                    <label for="peer-detail-fec-group-hold-depth">fec_group_hold_depth <span>(blank=auto)</span></label>
                    <input id="peer-detail-fec-group-hold-depth" [(ngModel)]="peerDetailModel.fecGroupHoldDepth" placeholder="auto" />
                </div>
            </div>

            <div class="actions">
                <button type="button" class="btn save" [disabled]="overlayPlusCrudLoading" (click)="savePeerDetail(applyActivationDialog)">
                    <span class="btn-spinner" *ngIf="isPeerCrudLoading('edit')"></span>
                    {{isPeerCrudLoading('edit') ? 'Updating Peer...' : 'Save & Apply'}}
                </button>
                <button type="button" class="btn get" [disabled]="overlayPlusCrudLoading" (click)="openPeerProvisioningModal(peerProvisioningDialog)">Get Provisioning</button>
                <button type="button" class="btn muted" [disabled]="overlayPlusCrudLoading" mat-dialog-close>Close</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #peerProvisioningDialog>
    <div class="peer-provisioning-dialog">
        <h2 mat-dialog-title>{{peerProvisioningTitle}}</h2>
        <div mat-dialog-content>
            <div class="provisioning-label">UI Block - paste into device Overlay Plus -> Add New Overlay</div>
            <pre class="ui-block-output">{{peerProvisioningUiBlock}}</pre>
            <button type="button" class="mini-btn copied-btn" *ngIf="copiedProvisioningTarget === 'peer-ui'">Copied</button>
            <button type="button" class="mini-btn" *ngIf="copiedProvisioningTarget !== 'peer-ui'" (click)="copyProvisioningText(peerProvisioningUiBlock, 'peer-ui')">Copy</button>

            <div class="provisioning-label cli-label">CLI Script - paste into device SSH terminal</div>
            <pre class="cli-script-output">{{peerProvisioningCliScript}}</pre>
            <button type="button" class="mini-btn copied-btn" *ngIf="copiedProvisioningTarget === 'peer-cli'">Copied</button>
            <button type="button" class="mini-btn" *ngIf="copiedProvisioningTarget !== 'peer-cli'" (click)="copyProvisioningText(peerProvisioningCliScript, 'peer-cli')">Copy</button>
        </div>
        <div mat-dialog-actions class="dialog-actions peer-dialog-actions">
            <button type="button" class="cancel-btn" mat-dialog-close>Close</button>
        </div>
    </div>
</ng-template>

<ng-template #applyActivationDialog>
    <div class="confirm-delete-dialog apply-activation-dialog">
        <div class="apply-confirm-head">
            <div class="apply-confirm-badge">Saved</div>
            <div>
                <h2 mat-dialog-title>{{applyConfirmModel.title}}</h2>
                <p>{{applyConfirmModel.message}}</p>
            </div>
        </div>
        <div mat-dialog-content>
            <div class="apply-confirm-notes">
                <div class="apply-confirm-note">
                    <strong>No</strong>
                    <span>Config saved and you can apply it later</span>
                </div>
                <div class="apply-confirm-note apply-now-note">
                    <strong>Yes</strong>
                    <span>Immediately send to device and apply</span>
                </div>
            </div>
        </div>
        <div mat-dialog-actions class="dialog-actions confirm-dialog-actions">
            <button type="button" class="cancel-btn apply-later-btn" (click)="cancelApplyActivation()" mat-dialog-close>No, Later</button>
            <button type="button" class="save-btn apply-now-btn" (click)="confirmApplyActivation(applyAutomaticProcessDialog)">Yes, Apply Now</button>
        </div>
    </div>
</ng-template>

<ng-template #applyAutomaticProcessDialog>
    <div class="apply-process-dialog">
        <div class="apply-process-container">
            <div class="apply-process-title">Apply Automatic</div>

            <div class="apply-process-step" *ngFor="let step of applyProcessSteps; let stepIndex = index" [ngClass]="step.status">
                <div class="apply-step-number">
                    <span *ngIf="step.status !== 'completed'">{{stepIndex + 1}}</span>
                    <span *ngIf="step.status === 'completed'">&#10003;</span>
                </div>
                <div class="apply-step-content">
                    <div class="apply-step-head">
                        <h3>{{step.title}}</h3>
                        <span class="apply-step-status">{{step.status}}</span>
                    </div>
                    <p>{{step.description}}</p>
                    <div class="apply-step-error" *ngIf="step.status === 'failed'">{{step.error}}</div>
                    <div class="apply-failed-actions" *ngIf="step.status === 'failed'">
                        <button type="button" class="mini-btn apply-retry-btn" (click)="retryApplyProcessStep(step.key)">
                            {{step.key === 'assertOk' ? 'Retry VCE Provisioning' : 'Retry'}}
                        </button>
                        <button type="button" class="mini-btn apply-abort-btn" (click)="abortApplyProcess()">Abort</button>
                    </div>

                    <div class="apply-existing-actions" *ngIf="step.key === 'vceProvision' && step.status === 'waiting'">
                        <div class="apply-existing-note">VCE provisioning already exists for this peer.</div>
                        <button type="button" class="save-btn" (click)="chooseExistingVceProvision(true)">Update Existing</button>
                        <button type="button" class="cancel-btn" (click)="chooseExistingVceProvision(false)">Discard Operation</button>
                    </div>
                </div>
            </div>

            <div class="apply-process-actions" *ngIf="applyProcessComplete">
                <button type="button" class="save-btn apply-now-btn" (click)="closeApplyProcess()">Done</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #confirmDeleteDialog>
    <div class="confirm-delete-dialog">
        <h2 mat-dialog-title>{{confirmDeleteModel.title}}</h2>
        <div mat-dialog-content>
            <p>{{confirmDeleteModel.message}}</p>
            <div class="confirm-target">{{confirmDeleteModel.targetName}}</div>
        </div>
        <div mat-dialog-actions class="dialog-actions confirm-dialog-actions">
            <button type="button" class="cancel-btn" [disabled]="overlayPlusCrudLoading" mat-dialog-close>Cancel</button>
            <button type="button" class="danger-btn" [disabled]="overlayPlusCrudLoading" (click)="confirmDelete()">
                <span class="btn-spinner" *ngIf="isDpcCrudLoading('delete') || isPeerCrudLoading('delete')"></span>
                {{isDpcCrudLoading('delete') ? 'Deleting DPC...' : (isPeerCrudLoading('delete') ? 'Deleting Peer...' : (confirmDeleteModel.type === 'dpc' ? 'Remove' : 'Delete'))}}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #newDpcDialog>
    <div class="dpc-mock-dialog" [class.edit-dpc-dialog]="dpcDialogMode === 'edit'">
        <h2 mat-dialog-title>{{dpcDialogMode === 'edit' ? 'Edit DPC - ' + (newDpcModel.name || '-') : 'Add New DPC'}}</h2>
        <div mat-dialog-content>
            <div class="dpc-mock-grid">
                <div class="dpc-mock-field" [class.invalid-field]="isDpcFieldInvalid('name')">
                    <label for="dpc-name">DPC Name <strong class="required-star">*</strong> <small>{{dpcDialogMode === 'edit' ? '(read-only)' : '(auto-assigned, editable)'}}</small></label>
                    <input id="dpc-name" type="text" [(ngModel)]="newDpcModel.name" placeholder="dpc1" />
                    <span class="field-error" *ngIf="isDpcFieldInvalid('name')">DPC Name is required.</span>
                </div>
                <div></div>
                <div class="dpc-mock-field" [class.invalid-field]="isDpcFieldInvalid('listenAddr')">
                    <label for="dpc-listen-address">Listen Addr <strong class="required-star">*</strong> <small>(e.g. 0.0.0.0:3122)</small></label>
                    <input id="dpc-listen-address" type="text" [(ngModel)]="newDpcModel.listenAddr" placeholder="0.0.0.0:3121" />
                    <span class="field-error" *ngIf="isDpcFieldInvalid('listenAddr')">Listen Addr is required.</span>
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-mtu">MTU</label>
                    <input id="dpc-mtu" type="number" [(ngModel)]="newDpcModel.mtu" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-forward-address">Forward Addr <small>(e.g. 127.0.0.1:4022)</small></label>
                    <input id="dpc-forward-address" type="text" [(ngModel)]="newDpcModel.forwardAddr" placeholder="127.0.0.1:4021" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-max-packet-size">Max Packet Size</label>
                    <input id="dpc-max-packet-size" type="number" [(ngModel)]="newDpcModel.maxPacketSize" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-server-url">Server URL <small>(FQDN:port for vCEs)</small></label>
                    <input id="dpc-server-url" type="text" [(ngModel)]="newDpcModel.serverUrl" [attr.list]="dpcServerUrlOptions.length ? 'dpc-server-url-options' : null" [placeholder]="getDefaultDpcServerUrl()" />
                    <datalist id="dpc-server-url-options">
                        <option *ngFor="let serverUrl of dpcServerUrlOptions" [value]="serverUrl"></option>
                    </datalist>
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-fec-ratios">FEC Ratios <small>(comma-separated)</small></label>
                    <input id="dpc-fec-ratios" type="text" [(ngModel)]="newDpcModel.fecRatios" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-ip">DPC IP (CIDR) <small>(blank = proxy mode)</small></label>
                    <input id="dpc-ip" type="text" [(ngModel)]="newDpcModel.dpcIp" placeholder="10.0.43.254/24" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-fec-timeout">FEC Timeout (ms)</label>
                    <input id="dpc-fec-timeout" type="number" [(ngModel)]="newDpcModel.fecTimeout" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-tunnel-ip">Tunnel IP <small>(auto from DPC IP if blank)</small></label>
                    <input id="dpc-tunnel-ip" type="text" [(ngModel)]="newDpcModel.tunnelIp" placeholder="auto" />
                </div>
                <div class="dpc-mock-field">
                    <label for="dpc-sdwan-link">SDWAN Link <small>(e.g. link6)</small></label>
                    <input id="dpc-sdwan-link" type="text" [(ngModel)]="newDpcModel.sdwanLink" placeholder="link6" />
                </div>
                <div></div>
                <div class="dpc-mock-field">
                    <label for="dpc-qos-rate">QoS Rate <small>(e.g. 800mbit)</small></label>
                    <input id="dpc-qos-rate" type="text" [(ngModel)]="newDpcModel.qosRate" placeholder="800mbit" />
                </div>
            </div>
            <div class="dpc-mock-checks">
                <label>
                    <input type="checkbox" [(ngModel)]="newDpcModel.authRequired" />
                    Auth Required
                </label>
                <label>
                    <input type="checkbox" [(ngModel)]="newDpcModel.enabled" />
                    Enabled
                </label>
            </div>
            <div class="dpc-mock-note">
                Auto-set on save: <code>ip4table</code>, <code>dmz_ipset</code>, <code>wan_ipset</code> (derived from DPC name)
            </div>
        </div>
        <div mat-dialog-actions class="dpc-mock-actions">
            <button type="button" class="dpc-mock-cancel" [disabled]="overlayPlusCrudLoading" mat-dialog-close>Cancel</button>
            <button type="button" class="dpc-mock-add" [disabled]="overlayPlusCrudLoading" (click)="saveDpc()">
                <span class="btn-spinner" *ngIf="isDpcCrudLoading('add') || isDpcCrudLoading('edit')"></span>
                {{getDpcSaveButtonText()}}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #expandedLaneChart let-graph>
    <h2 mat-dialog-title>{{graph.title}}</h2>
    <mat-dialog-content>
        <div style="height: 65vh; min-height: 300px; position: relative;">
            <canvas baseChart [datasets]="graph.data" [labels]="graph.labels"
                [options]="graph.options" [colors]="laneAnalyticsChartColors"
                [legend]="true" [chartType]="laneAnalyticsChartType"
                [plugins]="laneAnalyticsChartPlugins"></canvas>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end"><button mat-button mat-dialog-close>Close</button></mat-dialog-actions>
</ng-template>

<ng-template #laneAnalyticsTimezonePicker>
    <mat-form-field class="lane-analytics-timezone-picker" appearance="outline">
        <mat-label>Timezone</mat-label>
        <svg matPrefix class="timezone-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <circle cx="12" cy="12" r="9"></circle><ellipse cx="12" cy="12" rx="4" ry="9"></ellipse>
            <path d="M3 12h18M5 6h14M5 18h14"></path>
        </svg>
        <mat-select [value]="selectedLaneAnalyticsTimezone" panelClass="lane-timezone-panel"
            (selectionChange)="onLaneAnalyticsTimezoneChange($event.value)"
            (openedChange)="laneAnalyticsTimezoneSearch = ''">
            <div class="lane-timezone-search">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m16 16 5 5"></path></svg>
                <input matInput [(ngModel)]="laneAnalyticsTimezoneSearch"
                    [ngModelOptions]="{standalone: true}" placeholder="Search city or timezone"
                    aria-label="Search Timezone" (keydown)="$event.stopPropagation()">
            </div>
            <mat-option *ngFor="let tz of laneAnalyticsTimezones | searchSelect : laneAnalyticsTimezoneSearch" [value]="tz.tz">
                {{tz.name}}, {{tz['tz-posix']}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>
